<template>
  <Layout>
    <Content class="homeContent">
      <Breadcrumb :style="{ margin: '5px 0' }">
        <BreadcrumbItem><h3>欢迎使用星梦运营服务系统!</h3></BreadcrumbItem>
      </Breadcrumb>
      <div :style="{ 'font-size': '14px' }">
        <br />
        <div>
          为切实保护客户数据安全及客户隐私权，请按相关要求合规操作。系统将自动记录保存账号的所有操作记录。
        </div>
        <br />
        <br />
        <div>
          * 请注意保护客户隐私数据。<br />
          * 请务向他人透露或提供客户信息。<br />
          * 请您确保自己的账号密码安全。
        </div>
      </div>
    </Content>
  </Layout>
</template>
<style>
.homeContent{
  height: calc(100vh - 64px);
  padding: 10px;
  min-height: 600px;
/* background: white;*/
}

</style>
<script>
export default {
  data() {
    return {};
  },
  mounted: function () {},
  computed: {},
  methods: {},
};
</script>
